import React from "react";
import Card from "../Card";
import Card2 from "../Card/Card2";

const Articles = ({ articles }) => {
  const leftArticlesCount = Math.ceil(articles.length / 5);
  const leftArticles = articles.slice(0, articles.length / 2);
  const rightArticles = articles.slice(leftArticlesCount, 3);

  return (
    <div className="flex flex-col lg:flex-row">
      <div className="flex flex-col lg:flex-row lg:w-7/12">
        {leftArticles.map((article, i) => {
          return <Card article={article} key={`article__${article.slug}`} />;
        })}
      </div>
      <div>
        <div>
          {rightArticles.map((article, i) => {
            return <Card2 article={article} key={`article__${article.slug}`} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Articles;
